import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  width: 800px;
  z-index: 1000;
`;

export const Image = styled.img`
  width: 100%;
  height: 500px;
  background-color: #000;
  background-size: cover;
  background-position: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 10px 2px;
  gap: 10px;
`;

export const Content = styled.div`
  height: 440px;
  display: flex;
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
`;
